import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend, } from "chart.js";
import { toast } from "react-toastify";
import DtlViewModal from "./Dtl_View_Modal";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

/*
 npm install file-saver
*/
const Rpt_Budget_Alloc = () => {

  const [chartData, setChartData] = useState(null);
  const [paramYear1, setParamYear1] = useState();
  const [finYears, setFinYears] = useState([]);
  const [budgetData, setBudgetData] = useState([]);
  const [budgetName, setBudgetName] = useState();

  const [showDtlModal, setShowDtlModal] = useState(false);
  const [finData, setFinData] = useState([]);
  const [voucherLoading, setVoucherLoading] = useState(false);

  useEffect(() => {

    async function fetchChartData() {
      try {

        const yearRes = await axios.get(`${BASE_URL}/api/ddl_fin_year`);
        setFinYears(yearRes.data);

        setParamYear1(yearRes.data[0].year1);

        GetBudgetData(yearRes.data[0].year1);

      } catch (err) {
        console.error("Error loading data", err);
      }
    }

    fetchChartData();

  }, []);

  const handleRunReport = async () => {

    try {

      setChartData([]);
      GetBudgetData(paramYear1);

    } catch (error) {
     alert('Error in handleRunReport : ', error);
   }
 
  };

  const GetBudgetData = async (pFinYear1) => {
    try {


      setBudgetData([]);
      const res = await axios.get(`${BASE_URL}/api/rpt_Budget_Plan_Act`, { params: { p_FinYear1: pFinYear1 } });

      if (res.data.length > 0) {
        setBudgetData(res.data);
      }

    } catch (err) {
      console.error("Error loading Budget Data", err);
    }

  }

  const GetDataforChart = async (pFinYear1) => {
    try {

      const res = await axios.get(`${BASE_URL}/api/rpt_BgtAlloc`, { params: { p_FinYear1: pFinYear1 } });

      // Map database fields to arrays

      if (res.data.length > 0) {
        const categories = res.data.map((row) => row.budget);
        const actualValues = res.data.map((row) => row.actual_amt);
        const plannedValues = res.data.map((row) => row.planned_amt);
        const actualColors = res.data.map(r =>
          r.actual_amt > r.planned_amt
            ? "rgba(255, 0, 0, 0.8)"      // red
            : "rgba(0, 180, 0, 0.8)"       // green
        );
        setChartData({
          labels: categories,

          datasets: [
            {
              label: "Planned",
              data: plannedValues,
              backgroundColor: "rgba(54, 162, 235, 0.7)", // "rgba(255, 99, 132, 0.7)",
              borderRadius: 4,
              barThickness: 30,
            },
            {
              label: "Actual",
              data: actualValues,
              backgroundColor: actualColors,
              borderRadius: 4,
              barThickness: 30,
            },

          ],
        });
      } else {
        alert('Data not available.')
      }


    } catch (err) {
      console.error("Error loading chart data", err);
    }
  }

  const options = {

    responsive: true,
    plugins: {
//      legend: { position: "top" },
      legend: {
        position: "bottom",
        labels: {
          generateLabels: function () {
            return [
              {
                text: "Planned",
                fillStyle: "rgba(54,162,235,0.8)", // blue
                strokeStyle: "rgba(54,162,235,1)",
                lineWidth: 1,
              },
              {
                text: "Actual (Within)",
                fillStyle: "rgba(0, 180, 0, 0.8)", // green
                strokeStyle: "rgba(0, 180, 0, 1)",
                lineWidth: 1,
              },
              {
                text: "Actual (Exceeded)",
                fillStyle: "rgba(255, 0, 0, 0.8)", // red
                strokeStyle: "rgba(255, 0, 0, 1)",
                lineWidth: 1,
              }
            ];
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Amount",
        },
      },
      x: {
        stacked: false,
        ticks: { font: { size: 12 } },
        categoryPercentage: 0.4,  // << reduce category width
        barPercentage: 0.6,       // << reduce bar width inside category
      },
    },
  };

//  if (!chartData) return <p>Loading chart...</p>;
  ///// ***********************************************************************************
   //// Start Download handleDownloadExcel
  ///// ***********************************************************************************

  const handleDownloadExcel = () => {

    if (budgetData.length === 0) {
      alert("No data available");
      return;
    }

    const excelData = budgetData.map((n) => {

      const planned = Number(n.planned_amt || 0);
      const actual = Number(n.actual_amt || 0);

      const remaining = planned - actual;

      const usedPercent =
        planned > 0
          ? ((actual / planned) * 100).toFixed(0)
          : 0;

      const isParent = !n.sub_budget_name;

      let status = "Good";

      if (usedPercent > 95)
        status = "Critical";
      else if (usedPercent >= 80)
        status = "Near Limit";

      return {
        "Budget Head": isParent
          ? n.budget_name
          : `   ${n.sub_budget_name}`,

        Planned: planned,
        Actual: actual,
        Remaining: remaining,
        "Used %": `${usedPercent}%`,
        Status: status,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Budget Report"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob(
      [excelBuffer],
      {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      }
    );

    saveAs(data, "Budget_Report.xlsx");
  };

  ///// ***********************************************************************************
  /// End of Excel handleDownloadExcel
  ///// ***********************************************************************************

  ///// ***********************************************************************************
  //// Start of handleDownloadPDF
  ///// ***********************************************************************************
  const handleDownloadPDF = () => {

    if (budgetData.length === 0) {
      alert("No data available");
      return;
    }

    const lv_year1 = Number(paramYear1);
    const lv_year2 = lv_year1 + 1;

    const doc = new jsPDF("p", "mm", "a4");

    doc.setFontSize(16);

    doc.text(
      "Budget Planned vs Actual Report For " + lv_year1 + ' - ' + lv_year2,
      14,
      15
    );

    const tableColumn = [
      "Budget Head",
      "Planned",
      "Actual",
      "Remaining",
      "Used %",
      "Status",
    ];

    const tableRows = [];

    budgetData.forEach((n) => {

      const planned = Number(n.planned_amt || 0);

      const actual = Number(n.actual_amt || 0);

      const remaining = planned - actual;

      const usedPercent =
        planned > 0
          ? Math.round((actual / planned) * 100)
          : 0;

      // Parent row
      const isParent =
        n.budget_name &&
        !n.sub_budget_name;

      // Grand total row
      const isGrandTotal =
        !n.budget_name &&
        !n.sub_budget_name;

      let status = "Good";

      if (usedPercent > 95)
        status = "Critical";
      else if (usedPercent >= 80)
        status = "Near Limit";

      const budgetHead = isGrandTotal
        ? "Grand Total"
        : isParent
          ? n.budget_name
          : "   " + n.sub_budget_name;

      tableRows.push([
        budgetHead,

        planned.toLocaleString("en-IN"),

        actual.toLocaleString("en-IN"),

        remaining.toLocaleString("en-IN"),

        `${usedPercent}%`,

        status,
      ]);
    });

    autoTable(doc, {

      head: [tableColumn],
      body: tableRows,

      startY: 25,
      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 1.5,
        lineColor: [180, 180, 180],
        lineWidth: 0.2,
        valign: "middle",
      },

      // headStyles: {
      //   fillColor: [13, 110, 253],
      //   textColor: 255,
      //   fontStyle: "bold",
      // },

      headStyles: {
        fillColor: [91, 155, 213], // professional blue
        textColor: [0, 0, 0],      // black font
        fontStyle: "bold",
        lineWidth: 0.2,
      },

      columnStyles: {
        0: { halign: "left" },   // Budget Head
        1: { halign: "right" },  // Planned
        2: { halign: "right" },  // Actual
        3: { halign: "right" },  // Remaining
        4: { halign: "center" }, // Used %
        5: { halign: "center" }, // Status
      },

      didParseCell: function (data) {

        const row = budgetData[data.row.index];

        // Header row
        if (data.section === "head") {
          // Right-align Planned & Actual headers
          if (data.column.index === 1 || data.column.index === 2 || data.column.index === 3) {
            data.cell.styles.halign = "right";
          }
          return; // skip further processing for header
        }

        if (!row) return;

        const isParent =
          row.budget_name &&
          !row.sub_budget_name;

        const isGrandTotal =
          !row.budget_name &&
          !row.sub_budget_name;

        // Parent Budget Row
        if (isParent) {
          //data.cell.styles.fillColor = [221, 229, 236]; // blue-gray
          data.cell.styles.fillColor = [230, 230, 230];
          data.cell.styles.fontStyle = "bold";
        }

        // Grand Total Row
        if (isGrandTotal) {
          //data.cell.styles.fillColor = [180, 198, 231];
          data.cell.styles.fillColor = [200, 200, 200];
          data.cell.styles.fontStyle = "bold";
        }

      },

    });

    doc.save(`Budget_Report_${lv_year1}-${lv_year2}.pdf`);
  };

  /// End of handleDownloadPDF

  const handleView = async (row) => {
    try {

      if (row.actual_amt === '0') {
        toast.warning('No Amount spent on this Budget/Sub-Budget : ' + row.sub_budget_name);
        return;
      }

      setVoucherLoading(true);
      setBudgetName(row.budget_name);
      setFinData([]);

      // setSelectedBudget({
      //   bgt_id: row.bgt_id,
      //   sub_bgt_id: row.sub_bgt_id,
      //   budget_name: row.budget_name,
      //   sub_budget_name: row.sub_budget_name,
      // });

      let lv_sub_bgt_id = row.sub_bgt_id;

      if (!row.sub_budget_name || row.sub_budget_name === '') lv_sub_bgt_id = null;

      const res = await axios.get(`${BASE_URL}/api/rpt_detl_bgt_view`, {
          params: {
            p_year1: paramYear1,
            p_bgt_id: row.bgt_id,
            p_sbgt_id: lv_sub_bgt_id,
          },
        }
      );

      if (res.data && res.data.length > 0) {
        setFinData(res.data);
      } else {
        setFinData([]);
      }

      setShowDtlModal(true);

    } catch (err) {
      console.error("Error loading detailed data", err);
      toast.error("Unable to show Detailed data.");
    } finally {
      setVoucherLoading(false);
    }
  };



  return (
    <Container fluid className="p-2">
      <Card className="mb-1 p-1">

        <Row className="mt-2">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Select Year</InputGroup.Text>
              <select className="form-select"
                name="paramYear1" value={paramYear1} onChange={(e) => setParamYear1(e.target.value)}>
               {/* <option value="">-- Select Financial Year--</option> */}
                {finYears.map(fy => (
                  <option key={fy.year1} value={fy.year1}>{fy.fin_years}</option>
                ))}
              </select>
            </InputGroup>
          </Col>
          <Col md={9} className="d-flex justify-content-end">
            <Button className="me-2" variant="primary" onClick={handleDownloadExcel} style={{ width: "150px" }}
                    disabled={budgetData.length === 0}>Download Excel
            </Button>
            <Button className="me-2" variant="danger" onClick={handleDownloadPDF} style={{ width: "150px" }}
                    disabled={budgetData.length === 0}>Download PDF
            </Button>
            <Button className="me-2" variant="success" onClick={handleRunReport} style={{ width: "150px" }}>Run Report</Button>
          </Col>
        </Row>
       </Card>

      {/* Report Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 1, }}>
              <tr>
                <th style={{ textAlign: "center", width: "5%" }}>#</th>
                <th style={{ textAlign: "left", width: "25%" }}>Budget Head</th>
                <th style={{ textAlign: "right", width: "11%" }}>Planned</th>
                <th style={{ textAlign: "right", width: "11%" }}>Max Planned</th>
                <th style={{ textAlign: "right", width: "11%" }}>Utilized</th>
                <th style={{ textAlign: "right", width: "11%" }}>Remaining</th>
                <th style={{ textAlign: "center", width: "18%" }}>Used %</th>
                <th style={{ textAlign: "center", width: "8%" }}>Status</th>
                <th style={{ textAlign: "center", width: "5%" }}>View</th>
              </tr>
            </thead>

            <tbody>
              {budgetData.length > 0 ? (
                budgetData.map((n, idx) => {

                  const planned = Number(n.planned_amt || 0);
                  const max_planned = Number(n.max_amount || 0);
                  const actual = Number(n.actual_amt || 0);

                  const remaining = planned - actual;

                  const usedPercent =
                    planned > 0
                      ? Math.round((actual / planned) * 100)
                      : 0;

                  const isParent = !n.sub_budget_name;

                  const isGrandTotal = !n.budget_name && !n.sub_budget_name;

                  const getStatus = () => {
                    if (usedPercent > 95)
                      return { text: "Critical", color: "#dc3545" };

                    if (usedPercent >= 80)
                      return { text: "Near Limit", color: "#fd7e14" };

                    return { text: "Good", color: "#198754" };
                  };

                  const status = getStatus();

                  return (
                    <tr
                      key={idx}
                      style={{
                        backgroundColor: isGrandTotal
                          ? "#cfcfcf"     // grey for Grand Total
                          : isParent
                            ? "#e9ecef"     // light grey for Budget rows
                            : "#ffffff",    // white for Sub-budget rows
                        fontWeight: isGrandTotal
                          ? "700"
                          : isParent
                            ? "600"
                            : "400",
                        verticalAlign: "middle",
                      }}
                    >
                      <td style={{ textAlign: "center" }}>
                        {idx + 1}
                      </td>

                      {/* Budget Head */}
                      <td style={{ textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", }} >
                        {
                          !n.budget_name && !n.sub_budget_name
                            ? "Grand Total"
                            : isParent
                              ? n.budget_name
                              : n.sub_budget_name
                        }
                        {/* {isParent
                          ? n.budget_name
                          : `↳ ${n.sub_budget_name}`} */}
                      </td>

                      {/* Planned ₹ */}
                      <td style={{ textAlign: "right" }}>
                        {planned.toLocaleString("en-IN")}
                      </td>

                      {/* Max Planned Amount ₹ */}
                      <td style={{ textAlign: "right" }}>
                        {max_planned.toLocaleString("en-IN")}
                      </td>

                      {/* Actual ₹*/}
                      <td style={{ textAlign: "right" }}>
                        {actual.toLocaleString("en-IN")}
                      </td>

                      {/* Remaining */}
                      <td
                        style={{
                          textAlign: "right",
                          color: remaining < 0 ? "#dc3545" : "#198754",
                          fontWeight: "500",
                        }}
                      >
                        {remaining.toLocaleString("en-IN")}
                      </td>

                      {/* Used % */}
                      <td style={{ minWidth: "180px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", }} >
                          <div
                            style={{ flex: 1, height: "10px", background: "#e9ecef",
                              borderRadius: "10px", overflow: "hidden", }} >
                            <div
                              style={{ width: `${Math.min(usedPercent, 100)}%`,
                                height: "100%",
                                background:
                                  usedPercent > 95
                                    ? "#dc3545"
                                    : usedPercent >= 80
                                      ? "#fd7e14"
                                      : "#198754",
                              }}
                            />
                          </div>

                          <span
                            style={{
                              minWidth: "45px",
                              fontWeight: "500",
                            }}
                          >
                            {usedPercent}%
                          </span>
                        </div>
                      </td>

                      {/* Status */}
                      <td>
                        <span
                          style={{
                            background: status.color,
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        >
                          {status.text}
                        </span>
                      </td>
                      {/* <td style={{ textAlign: "center" }}>
                        <Button size="sm" disabled={isGrandTotal} 
                           variant={ isGrandTotal ? "secondary" : isParent ? "primary" : "success" }
                          onClick={() => handleView(n)} > View
                        </Button>
                      </td> */}
                      <td style={{ textAlign: "center" }}>
                        <Button size="sm" variant={ isGrandTotal ? "secondary" : isParent ? "primary" : undefined }
                          disabled={isGrandTotal} onClick={() => handleView(n)}
                          style={ !isGrandTotal && isParent
                              ? {
                                backgroundColor: "#8b5e3c",
                                borderColor: "#8b5e3c",
                                color: "#fff",
                              }
                              : {}
                          }
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Entry found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      </Card>


      {chartData && chartData.labels && chartData.labels.length > 0 ? (
        <div style={{ overflowX: "auto", width: "100%" }}>
          <div
            style={{
              width: `${chartData.labels.length * 160}px`,   // more space = no overlap
              minWidth: "1000px",
              height: "500px",
              padding: "20px",
            }}
          >
            <Bar data={chartData} options={options} />
          </div>
        </div>
      ) : (
        <p>No data available to display the chart.</p>
      )}

      <DtlViewModal
        show={showDtlModal}
        onHide={() => setShowDtlModal(false)}
        finData={finData}
        budgetName={budgetName}
        finYear1={paramYear1}
      />

    </Container>
    
  );


};

export default Rpt_Budget_Alloc;
